<div class="text-center" *ngIf="loader">
    <app-spinner></app-spinner>
</div>
<div>
    <div class="row w-100 mx-0 align-items-center px-0">
        <div class="col-md-6 px-0">
            <!-- <div class="justify-content-center text-danger" *ngIf="PatientsNotFound"> -->
            <!-- </div> -->
            <div class="justify-content-center text-danger" *ngIf="familyMembersList && familyMembersList.length===0">
                <p>Oops!! No family members found at this patient's address.</p>
            </div>
        </div>
        <div class="col-md-6 px-0">
            <div class="w-100 text-right">
                <button *ngIf="!FindAnotherPatientDetails" type="button"
                    class="btn btn-success btn-sm btn-neutral mb-1 mr-3" (click)="FindAnotherPatientDetail()">Find
                    Another Patient from a different Address</button>
            </div>
        </div>
    </div>
    
    <div *ngIf="FindAnotherPatientDetails" class="col-12 mb-1">
        <form [formGroup]="FindPatientForm" id="FindPatientForm" class="col-12">
            <h4 class="font-weight-light text-default">Find Patient Details to add as a Member  ooo</h4>
            <div class="form-row">
                <div class="form-group col-6">
                    <input type="text" class="form-control" placeholder="Patient Code *" maxlength="10"
                        formControlName="PatientRegID" required />
                </div>
                <div class="form-group col-6">
                    <input type="date" class="form-control" placeholder="Date of Birth *" formControlName="DOB" required />
                </div>
                <div class="form-group col-6">
                    <input type="text" class="form-control" placeholder="First Name *" maxlength="35"
                        formControlName="FirstName" required />
                </div>
                <div class="form-group col-6">
                    <input type="text" class="form-control" placeholder="Last Name *" maxlength="35"
                        formControlName="LastName" required />
                </div>
            </div>
            <div class="col-md-12 text-right">
                <button type="submit" (click)="findPatientDetails()" value="Find" class="btn btn-info px-5 ">
                    Find
                </button>
            </div>
        </form>
        <p class="font-weight-light text-danger" *ngIf="isAlreadyPresentInList">Patient has been already added to list.</p>
        <p class="text-danger" *ngIf="PatientsNotFound">Oops!! Patient details not found, please search again.</p>
    </div>
    <hr *ngIf="FindAnotherPatientDetails">

    
    <div *ngIf="foundPatientList && foundPatientList.length>0" class="">
        <table mat-table [dataSource]="foundPatientList" matSort class="mt-3">
            <ng-container matColumnDef="PatientName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Patient Name </th>
                <td mat-cell *matCellDef="let element">
                    <span>{{ element.Title }} {{ element.FirstName }} {{ element.LastName}} </span>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="DOB">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Birth </th>
                <td mat-cell *matCellDef="let element"> {{element.DOB}} </td>
            </ng-container>
    
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    <button type="submit" (click)="selectedPatient(element)" class="btn btn-outline-primary">
                        Select
                    </button>
                </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumnsPatientSearch"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsPatientSearch;"></tr>
        </table>
    
        <mat-paginator [pageSizeOptions]="[ 100, 50, 20]" showFirstLastButtons
            *ngIf="foundPatientList && foundPatientList.length>20" (page)="pageEventSearchMembers($event)">
        </mat-paginator>
    </div>
    
    <div class="w-100">
        <p class="text-danger" *ngIf="isNoFamilyHead">Select atleast one Family Head</p>
        <div *ngIf="familyMembersList && familyMembersList.length>0">
            <h3>Family Members List</h3>
            <input type="radio" name="IsFamilyHead" class="mt-3 mb-3" id={{SelectedPatientRecord.PatientID}}
                value={{SelectedPatientRecord.PatientID}} value={{SelectedPatientRecord.IsFamilyHead}}
                [checked]="SelectedPatientRecord.IsFamilyHead===1"
                (change)="isChangeFamilyHead($event,SelectedPatientRecord.PatientID,SelectedPatientRecord.FirstName+' '+SelectedPatientRecord.LastName)"> Mark
            <strong>{{ SelectedPatientRecord.Title }} {{SelectedPatientRecord.FirstName}}</strong> as the head of
            the family?
    
            <div *ngIf="familyMembersList && familyMembersList.length>0" class="">
                <table mat-table [dataSource]="familyMembersList" matSort class="mt-3">
                    <ng-container matColumnDef="PatientName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Patient Name </th>
                        <td mat-cell *matCellDef="let element">
                            <span>{{ element.Title }} {{ element.FirstName }} {{ element.LastName}} </span>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="IsPartoffamily">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Is Part of family</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <span *ngIf="element.IsPartOfFamily == 1">
                                <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
                            </span>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="Inthesameaddress">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> In the same address</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <span *ngIf="element.InSameAddress == 1">
                                <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
                            </span>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="IsFamilyHead">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Is Family Head</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <input type="radio" name="IsFamilyHead" id={{element.PatientID}} value={{element.PatientID}}
                                [checked]="SelectedPatientRecord.IsFamilyHead===0 && element.IsFamilyHead===1"
                                (change)="isChangeFamilyHead($event,element.PatientID,element.FirstName+' '+element.LastName)">
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="Action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <span *ngIf="element.IsPartOfFamily == 1" class="text-center">
                                <i class="fa fa-minus-circle text-danger mr-2 cursor" style="font-size:1rem"
                                    id="RemoveFamilyMember{{element.PatientID}}"
                                    (click)="AddFamilyMemberArray(element,$event)"></i>
                            </span>
                            <span *ngIf="element.IsPartOfFamily == 0" class="text-center">
                                <i class="fa fa-plus-circle text-success mr-2 cursor" style="font-size:1rem"
                                    id="AddFamilyMember{{element.PatientID}}"
                                    (click)="AddFamilyMemberArray(element,$event)"></i>
                            </span>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsPatient"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsPatient;"></tr>
                </table>
    
                <mat-paginator [pageSizeOptions]="[ 100, 50, 20]" showFirstLastButtons
                    *ngIf="familyMembersList && familyMembersList.length>20" (page)="pageEventSearchMembers($event)">
                </mat-paginator>
            </div>
    
        </div>
    </div>
    
    <div class="text-right w-100 mt-3 ">
        <p-button icon="pi pi-check" (click)="saveFamilyMember()" label="Save" styleClass="p-button-success mx-2"></p-button>
        <p-button icon="pi pi-times" (click)="cancelFamilyMember()" label="Cancel" styleClass="p-button-danger">
        </p-button>
    </div>
</div>

<app-toast-message></app-toast-message>